import { combineReducers } from "@reduxjs/toolkit";
import authSlice from "./slices/authSlice";
import userSlice from "./slices/userSlice";
import withDrawSlice from "./slices/withDrawSlice";

export const appReducers = combineReducers({
  auth: authSlice,
  user: userSlice,
  withDraw: withDrawSlice,
});

export const rootReducer = (state, action) => {
  // when a logout action is dispatched it will reset redux state
  if (action.type === "RESET") {
    localStorage.removeItem("persist:root");
    localStorage.removeItem("token");
  }
  return appReducers(state, action);
};
